import Controller from "@ember/controller";
import { computed } from "@ember/object";
import { i18n } from "discourse-i18n";
import { activityTypes } from "../../components/circles/card/stats";

export default class CircleActivityTopicsController extends Controller {
  get featuredMembers() {
    return this.model.featured_members;
  }

  @computed(
    ...activityTypes.map((type) => `args.model.category.topics_${type}`)
  )
  get activityStats() {
    return activityTypes
      .filter(
        (type) =>
          type === "all_time" || this.model.category[`topics_${type}`] > 0
      )
      .map((stat) =>
        i18n(`discourse_circles.circle.topics_stats.${stat}`, {
          count: this.model.category[`topics_${stat}`],
        })
      );
  }

  @computed("model.created_at")
  get createdAt() {
    return moment(this.model.created_at).format(
      i18n("dates.full_with_year_no_time")
    );
  }
}
